import { motion } from 'motion/react';
import { FunctionComponent, PropsWithChildren } from 'react';
import { adaptTransition } from '../../util/Animation';

type Props = PropsWithChildren<{
	expanded: boolean;
	maxScale?: number;
	minScale?: number;
}>;

export const SpringZoom: FunctionComponent<Props> = (props) => {
	const { maxScale = 1.25, minScale = 1 } = props;
	return <motion.div
		style={{
			transformOrigin: 'center',
		}}
		initial={{ scale: 1 }}
		animate={{ scale: props.expanded ? maxScale : minScale, }}
		transition={adaptTransition({
			type: 'spring',
			stiffness: 200,
			damping: 15,
			mass: 1,
		})}
	>
		{props.children}
	</motion.div>;
};